import { render, staticRenderFns } from "./FeatureTypeDetail.vue?vue&type=template&id=eb3e8838&scoped=true"
import script from "./FeatureTypeDetail.vue?vue&type=script&lang=js"
export * from "./FeatureTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeDetail.vue?vue&type=style&index=0&id=eb3e8838&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3e8838",
  null
  
)

export default component.exports